import Vue from "vue";
const vm = new Vue();

export const statusCommission = status => {

    switch ( String(status) ) {
        case '0':
            return { status: `รอดำเนินการ` , color: `primary`}
        case '1':
            return { status: `รอส่งเอกสารออฟไลน์` , color: `primary`} 
        case '2':
            return { status: `ยืนยันตัวตนแล้ว` , color: `success`}
        case '-1':
            return { status: `รอยืนยัน` , color: `warning`}
        case '-2':
            return { status: `ยืนยันตัวตนไม่ผ่าน` , color: `danger`}
        case '-3':
            return { status: `ยืนยันตัวตนไม่ผ่าน ${vm.$THEME.webTitle}` , color: `danger`}
        default:
            return { status: `ยังไม่ยืนยันตัวตน` , color: `dark`}
    }
};